<template>
  <v-container style="margin-top: -20px">
    <v-row>
      <div class="board animated-bg" :class="{ 'animated-bg': true }">
        <img :src="require('@/assets/primo_blocco.jpg')" style="width: 100%;" />
      </div>
    </v-row>
    <v-row>
      <div class="board2">
        <img :src="require('@/assets/secondo_blocco.jpg')" style="width: 100%;" />
      </div>
    </v-row>
    <v-row>
      <div class="board3">
        <v-card elevation="3"
          style="padding:10px;border-radius: 12px; max-width: 500px;margin:auto;margin-top: 50px; margin-bottom: 40px; background-color: white; font-size: 10px;">

          <v-card-text>
            <v-form ref="form">
              <v-text-field v-model="name" label="Nome" required variant="solo-filled"></v-text-field>
              <v-text-field v-model="surname" label="Cognome" required variant="solo-filled"></v-text-field>
              <v-text-field v-model="jobTitle" label="Job Title" variant="solo-filled"></v-text-field>
              <v-text-field v-model="email" label="Email" type="email" required variant="solo-filled"></v-text-field>
              <v-text-field v-model="phoneNumber" label="Numero di Telefono" type="tel"
                variant="solo-filled"></v-text-field>
              <v-divider class="my-4"></v-divider>
              <div style="text-align: center;">
                <h3 style="margin-bottom: 10px;">Scarica il materiale</h3>
                <v-btn href="/EPEople/materiale.zip" download style="margin: 5px; border-radius: 10px;" color="primary"
                  variant="elevated">
                  Scarica cartella (ZIP)
                </v-btn>
              </div>


              <div style="text-align: center;margin-top: 10px;">
                <h3 style="margin-bottom: 10px;">Carica i tuoi lavori</h3>
                <v-file-input :model-value="uploadedFiles" @update:model-value="uploadedFiles = $event"
                  label="Carica file zip" multiple prepend-icon="mdi-paperclip" show-size variant="solo-filled" />

              </div>
              <div style="display: flex; align-items: center;">
                <v-checkbox v-model="privacyPolicy" hide-details
                  label="Dichiaro di aver letto e accetto la "></v-checkbox>

                <a href="https://www.iubenda.com/privacy-policy/16268737" target="_blank" rel="noopener noreferrer"
                  style="margin-left: 8px;">
                  Privacy Policy
                </a>
              </div>

              <v-checkbox v-model="dataTreatment"
                label="Con l'iscrizione all'evento,l'interessato acconsente al trattamento dei dati personali forniti,come descritto nella presente Privacy Policy"></v-checkbox>
              <v-checkbox v-model="dataNews"
                label="Vuoi ricevere news riguardo all'evento che verrà organizzato in Superstudio 13?"></v-checkbox>
            </v-form>
          </v-card-text>
          <v-overlay :model-value="isLoading" class="d-flex align-center justify-center" persistent>
            <v-progress-circular indeterminate size="64" color="primary" />
          </v-overlay>
          <v-card-actions class="d-flex justify-center">
            <v-btn color="primary" @click="submitForm" :disabled="!formIsValid"
              style="background-color: #5e5e5e; color: white; border-radius: 10px; padding: 10px;width: 300px;height: 60px;"><span
                style="font-size: x-large;font-weight: bold;color: white;">Registrati</span></v-btn>
          </v-card-actions>
        </v-card>

        <!-- Modale di conferma -->
        <v-dialog v-model="showSuccessModal" max-width="400">
          <v-card class="pa-4 text-center">
            <v-card-title class="text-h5">Registrazione Avvenuta</v-card-title>
            <v-card-text>
              La registrazione è avvenuta con successo!
            </v-card-text>
          </v-card>
        </v-dialog>

      </div>
    </v-row>
  </v-container>
</template>
  
<script>
import axios from 'axios';
export default {
  name: 'CustomersRegistration',
  props: {
    currentUsername: String,
  },
  data() {
    return {
      username: localStorage.getItem('user'),
      name: '',
      surname: '',
      company: '',
      jobTitle: '',
      email: '',
      phoneNumber: '',
      privacyPolicy: false,
      dataTreatment: false,
      showSuccessModal: false, // Stato per mostrare la modale        
      privacyLabel: 'Dichiaro di aver letto la',
      uploadedFiles: [],
      isLoading: false, // 👈 nuova variabile
      dataNews: false,
    };
  },
  computed: {
    formIsValid() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.privacyPolicy &&
        this.dataTreatment
      );
    },
  },
  methods: {
    async submitForm_Registrazione() {
      try {
        const response = await axios.post(process.env.VUE_APP_SERVER2 + '/sendCustomEmail', {
          to: 'comunicazione@e-photo.it',
          subject: `Nuova registrazione di ${this.name} ${this.surname}`,
          text: `
              Nome: ${this.name}
              Cognome: ${this.surname}
              Azienda: ${this.company}
              Job Title: ${this.jobTitle}
              Email: ${this.email}
              Telefono: ${this.phoneNumber}
            `,
          comment: this.email,
          cc: 'hr@e-photo.it',
          ccn: 'eugenio.bubba@e-photo.it',
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 200) {
          this.resetForm();
          this.showSuccessModal = true; // Mostra la modale

          // Chiudi automaticamente la modale dopo 3 secondi
          setTimeout(() => {
            this.showSuccessModal = false;
          }, 3000);
        } else {
          console.log('Errore durante l\'invio della registrazione');
        }
      } catch (error) {
        console.error('Errore durante l\'invio della registrazione:', error);
      }
    },
    async submitForm() {
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append('to', 'comunicazione@e-photo.it');
        formData.append('subject', `Nuova registrazione di ${this.name} ${this.surname}`);
        formData.append('text', `
          Nome: ${this.name}
          Cognome: ${this.surname}
          Azienda: ${this.company}
          Job Title: ${this.jobTitle}
          Email: ${this.email}
          Telefono: ${this.phoneNumber}
          Newsletter: ${this.dataNews}
        `);
        formData.append('comment', this.email);
        formData.append('cc', 'hr@e-photo.it');
        formData.append('ccn', 'eugenio.bubba@e-photo.it');

        console.log('File caricati:', this.uploadedFiles);
        // Aggiunta file (se presenti)
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
          this.uploadedFiles.forEach(file => {
            formData.append('files', file);
          });
        }

        const response = await axios.post(
          process.env.VUE_APP_SERVER4 + '/sendCustomEmail',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        if (response.status === 200) {
          this.resetForm();
          this.showSuccessModal = true;

          setTimeout(() => {
            this.showSuccessModal = false;
          }, 3000);
        } else {
          console.log('Errore durante l\'invio della registrazione');
        }
      } catch (error) {
        console.error('Errore durante l\'invio della registrazione:', error);
      } finally {
        this.isLoading = false; // ✅ fine loading
      }
    },

    resetForm() {
      this.name = '';
      this.surname = '';
      this.company = '';
      this.jobTitle = '';
      this.email = '';
      this.phoneNumber = '';
      this.privacyPolicy = false;
      this.dataTreatment = false;
      this.uploadedFiles = [];
      this.dataNews = false;
    },
  },
  mounted() {
  },
};
</script>
  
<style scoped>  .board {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    background-image: url('@/assets/Iridescent_Light_Spectrum2.jpg');
    /* Percorso dell'immagine */
    background-size: cover;
    background-repeat: repeat;
    background-position: center;
  }

  .board2 {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    background-size: cover;
    background-repeat: repeat;
    background-position: center;
    background-color: white;
  }

  .board3 {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    background-size: cover;
    background-repeat: repeat;
    background-position: center;
    background-color: #4A4A4A;
  }

  .animated-bg {
    animation: slideBackground 3s linear infinite;

  }

  /* Keyframe for the sliding background */
  @keyframes slideBackground {
    0% {
      background-position: 0% 100%;
    }

    50% {
      background-position: 5% 5%;
    }

    100% {
      background-position: 0% 100%;
    }
  }
</style>
  